import { customFilterGroupResolvers as f, getFindStationFilters as p, getFindStationQuickFilters as A } from "../data/filters.js";
import "lodash-es";
import { useTranslation as _ } from "react-i18next";
const T = (t, r) => {
  switch (t) {
    case "propellants":
      return r("FIND_STATION_FILTER_GROUP_LABEL_PROPELLANTS");
    case "services":
      return r("FIND_STATION_FILTER_GROUP_LABEL_SERVICES");
    case "electricCharging":
      return r("FIND_STATION_FILTER_GROUP_LABEL_ELECTRIC_CHARGING");
    default:
      return "";
  }
}, d = (t, r) => {
  switch (t) {
    case "chargerPower":
      return r("FIND_STATION_FILTER_SUB_GROUP_LABEL_CHARGER_EFFECT");
    case "chargerStandard":
      return r("FIND_STATION_FILTER_SUB_GROUP_LABEL_CHARGER_STANDARD");
    default:
      return null;
  }
}, G = (t) => {
  const r = [];
  for (const e of t)
    r.includes(e.group) || r.push(e.group);
  return r;
}, S = (t) => {
  const r = f.find((e) => e.groupName === t);
  return r?.filterFunction ? r?.filterFunction : () => (console.log(`Invalid filter finction for group: ${t}`), []);
}, u = (t) => Array.from(t, ([e, o]) => ({
  group: o.group,
  name: e,
  value: o.value
})), E = (t, r) => {
  const e = u(r);
  return e.length === 0 ? t : G(e).reduce(
    (s, i) => S(i)(s, e),
    [...t]
  );
}, I = (t) => {
  const r = u(t), e = [], { t: o } = _(), c = p(o), s = A(o), i = [...c, ...s];
  for (const l of r) {
    const n = i.find(
      (a) => a.name === l.name
    ), F = n?.type === "checkbox" ? n.label : n?.labels[l.value];
    F && e.push(F);
  }
  return e;
}, m = (t, r) => u(t).filter((o) => o.group === r).map((o) => `${o.name}:${o.value}`).join(", ");
export {
  E as filterStations,
  T as getLabelForFilterGroup,
  d as getLabelForFilterSubGroup,
  I as getLabelsForSelectedFilters,
  m as getValuesAsStringFromFilterGroup
};
